import JSEncrypt from 'jsencrypt';

export const ENCRYPT_CONFIG = {
  PUBLIC_KEY: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCGqLO0UNC87/wD37ZXVhRBc/UQXHGXm+I6uimWhJ7EViq5PfXXSTD0nibVnqfXsPGVlYzrwl5pffgQOyzDgxAOutADMbmpk3rAISGDslwQJ95wQRKOyedq/ezwaL68bO78qvHC9R+WA9tPivlSA9b9bui9BXHYPBUhk0/voGuvCQIDAQAB',
  TYPE: 'RSA',
};

const encrypt = new JSEncrypt();

// 设置公钥
encrypt.setPublicKey(ENCRYPT_CONFIG.PUBLIC_KEY);


// 加密
export const getEncrypt = (data) => encrypt.encrypt(data);
